import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      isAuthenticated: false,
      isLoading: true,
      
      setUser: (user) => set({ user, isAuthenticated: !!user, isLoading: false }),
      
      login: () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + '/dashboard';
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
      },
      
      processSession: async (sessionId) => {
        try {
          const response = await fetch(`${API_URL}/api/auth/session`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ session_id: sessionId }),
            credentials: 'include'
          });
          
          if (!response.ok) throw new Error('Auth failed');
          
          const user = await response.json();
          set({ user, isAuthenticated: true, isLoading: false });
          return user;
        } catch (error) {
          console.error('Session processing failed:', error);
          set({ user: null, isAuthenticated: false, isLoading: false });
          throw error;
        }
      },
      
      checkAuth: async () => {
        try {
          const response = await fetch(`${API_URL}/api/auth/me`, {
            credentials: 'include'
          });
          
          if (!response.ok) {
            set({ user: null, isAuthenticated: false, isLoading: false });
            return null;
          }
          
          const user = await response.json();
          set({ user, isAuthenticated: true, isLoading: false });
          return user;
        } catch (error) {
          set({ user: null, isAuthenticated: false, isLoading: false });
          return null;
        }
      },
      
      logout: async () => {
        try {
          await fetch(`${API_URL}/api/auth/logout`, {
            method: 'POST',
            credentials: 'include'
          });
        } catch (error) {
          console.error('Logout error:', error);
        }
        set({ user: null, isAuthenticated: false, isLoading: false });
      }
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ user: state.user, isAuthenticated: state.isAuthenticated })
    }
  )
);
